var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-modal",
    {
      attrs: {
        visible: true,
        closable: true,
        footer: null,
        width: 700,
        centered: "",
        wrapClassName: "auto-rebalance-promo-modal",
      },
      on: { cancel: _vm.handleClose },
    },
    [
      _c("div", { staticClass: "auto-rebalance-promo" }, [
        _c("div", { staticClass: "promo-header" }, [
          _c("div", { staticClass: "icon-container" }, [
            _c("span", { staticClass: "material-icons" }, [
              _vm._v("autorenew"),
            ]),
          ]),
          _vm._v(" "),
          _c("h2", [
            _vm._v(_vm._s(_vm.$t("settings.autoRebalancePromoTitle"))),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "subtitle" }, [
            _vm._v(_vm._s(_vm.$t("settings.autoRebalancePromoSubtitle"))),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "promo-content" }, [
          _c("div", { staticClass: "features-grid" }, [
            _c("div", { staticClass: "feature-card" }, [
              _c("div", { staticClass: "feature-icon red" }, [
                _c("span", { staticClass: "material-icons" }, [
                  _vm._v("notifications_active"),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "feature-text" }, [
                _c("strong", [
                  _vm._v(
                    _vm._s(_vm.$t("settings.autoRebalancePromoFeat1Title"))
                  ),
                ]),
                _vm._v(" "),
                _c("span", [
                  _vm._v(
                    _vm._s(_vm.$t("settings.autoRebalancePromoFeat1Desc"))
                  ),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "feature-card" }, [
              _c("div", { staticClass: "feature-icon blue" }, [
                _c("span", { staticClass: "material-icons" }, [
                  _vm._v("refresh"),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "feature-text" }, [
                _c("strong", [
                  _vm._v(
                    _vm._s(_vm.$t("settings.autoRebalancePromoFeat2Title"))
                  ),
                ]),
                _vm._v(" "),
                _c("span", [
                  _vm._v(
                    _vm._s(_vm.$t("settings.autoRebalancePromoFeat2Desc"))
                  ),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "feature-card" }, [
              _c("div", { staticClass: "feature-icon green" }, [
                _c("span", { staticClass: "material-icons" }, [
                  _vm._v("check_circle"),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "feature-text" }, [
                _c("strong", [
                  _vm._v(
                    _vm._s(_vm.$t("settings.autoRebalancePromoFeat3Title"))
                  ),
                ]),
                _vm._v(" "),
                _c("span", [
                  _vm._v(
                    _vm._s(_vm.$t("settings.autoRebalancePromoFeat3Desc"))
                  ),
                ]),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "how-it-works" }, [
            _c("div", { staticClass: "steps-container" }, [
              _c("div", { staticClass: "step" }, [
                _c("div", { staticClass: "step-number" }, [_vm._v("1")]),
                _vm._v(" "),
                _c("div", { staticClass: "step-content" }, [
                  _c("strong", [
                    _vm._v(
                      _vm._s(_vm.$t("settings.autoRebalancePromoStep1Title"))
                    ),
                  ]),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(
                      _vm._s(_vm.$t("settings.autoRebalancePromoStep1Example"))
                    ),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "step-arrow" }, [_vm._v("→")]),
              _vm._v(" "),
              _c("div", { staticClass: "step" }, [
                _c("div", { staticClass: "step-number" }, [_vm._v("2")]),
                _vm._v(" "),
                _c("div", { staticClass: "step-content" }, [
                  _c("strong", [
                    _vm._v(
                      _vm._s(_vm.$t("settings.autoRebalancePromoStep2Title"))
                    ),
                  ]),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(
                      _vm._s(_vm.$t("settings.autoRebalancePromoStep2Example"))
                    ),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "step-arrow" }, [_vm._v("→")]),
              _vm._v(" "),
              _c("div", { staticClass: "step" }, [
                _c("div", { staticClass: "step-number" }, [_vm._v("3")]),
                _vm._v(" "),
                _c("div", { staticClass: "step-content" }, [
                  _c("strong", [
                    _vm._v(
                      _vm._s(_vm.$t("settings.autoRebalancePromoStep3Title"))
                    ),
                  ]),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(
                      _vm._s(_vm.$t("settings.autoRebalancePromoStep3Desc"))
                    ),
                  ]),
                ]),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "promo-actions" },
            [
              _c(
                "a-button",
                {
                  staticClass: "activate-btn",
                  attrs: { type: "primary", size: "large" },
                  on: { click: _vm.handleActivate },
                },
                [
                  _c("span", { staticClass: "btn-content" }, [
                    _c("span", { staticClass: "material-icons" }, [
                      _vm._v("rocket_launch"),
                    ]),
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.$t("settings.autoRebalancePromoCta")) +
                        "\n                    "
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "a-button",
                { staticClass: "later-btn", on: { click: _vm.handleClose } },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.$t("settings.autoRebalancePromoLater")) +
                      "\n                "
                  ),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "reminder-checkbox" },
            [
              _c(
                "a-checkbox",
                {
                  model: {
                    value: _vm.dontShowAgain,
                    callback: function ($$v) {
                      _vm.dontShowAgain = $$v
                    },
                    expression: "dontShowAgain",
                  },
                },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(
                        _vm.$t("settings.autoRebalancePromoDontShowAgain")
                      ) +
                      "\n                "
                  ),
                ]
              ),
            ],
            1
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }